import React from 'react';

/**
 * Report Disclaimer & Limitation of Liability Content
 * 
 * This content is maintained separately for easier updates and legal compliance.
 * Last updated: 26 November 2025
 */

export const DisclaimerContent: React.FC = () => (
  <>
    <h4>1. Nature of the Service and Report</h4>
    <p>
      segmentor.app is an automated tool that generates reports using rule-based processing algorithms. Every report is produced automatically and is provided solely for general illustrative and informational purposes. It is NOT professional, legal, financial, tax, accounting, medical, technical, or any other regulated advice, and it must not be relied upon as such.
    </p>

    <h4>2. Express Acknowledgment of Risk</h4>
    <p>You expressly acknowledge and agree that:</p>
    <ul>
      <li>Automated outputs can be incorrect, incomplete, or based on incomplete or inaccurate input data</li>
      <li>You are solely responsible for verifying the accuracy and suitability of any report before using or relying on it</li>
      <li>No duty of care is owed to you beyond the supply of the digital content itself</li>
    </ul>

    <h4>3. Exclusion of Warranties and Conditions</h4>
    <p>
      To the fullest extent permitted by law, segmentor.app and its creator, distributor, licensors, and hosting providers supply the product and all reports strictly on an "as is" and "as available" basis and exclude all conditions, warranties, representations or other terms which might otherwise be implied by statute, common law or equity, including (without limitation) any implied conditions of satisfactory quality, fitness for a particular purpose, reasonable care and skill, accuracy, quiet enjoyment, or non-infringement.
    </p>

    <h4>4. Limitation and Exclusion of Liability</h4>
    <p>Nothing in this agreement excludes or limits liability for:</p>
    <ul>
      <li>(a) death or personal injury caused by negligence;</li>
      <li>(b) fraud or fraudulent misrepresentation; or reckless misrepresentation; or</li>
      <li>(c) any liability which cannot lawfully be excluded or limited.</li>
    </ul>
    <p>Subject to the above and to the fullest extent permitted by law:</p>
    <p>
      <strong>4.1</strong> Neither the creator nor any distributor, licensor, hosting provider or other supplier of segmentor.app shall be liable to you (whether in contract, tort (including negligence), breach of statutory duty, restitution or otherwise) for:
    </p>
    <ul>
      <li>any indirect, special, incidental, punitive, exemplary or consequential loss; or</li>
      <li>any loss of profit, revenue, business, anticipated savings, goodwill, reputation, data, or opportunity or use (in each case whether direct or indirect);</li>
    </ul>
    <p>
      <strong>4.2</strong> The entire aggregate liability of the creator and all distributors, licensors and hosting providers combined shall not exceed the greater of:
    </p>
    <ul>
      <li>(i) the amount you actually paid for the specific report that gave rise to the claim, or</li>
      <li>(ii) £100 (one hundred pounds sterling).</li>
    </ul>

    <h4>5. Basis of the Bargain & Reasonableness</h4>
    <p>
      You agree that the price charged for segmentor.app reflects the allocation of risk and the exclusions and limitations set out above, which are reasonable given the nature of an automated rule-based tool. These terms form an essential basis of the bargain between us.
    </p>

    <h4>6. Consumer Rights Act 2015 / Unfair Contract Terms</h4>
    <p>
      If you are a consumer, your statutory rights in respect of digital content that is faulty or not as described remain unaffected. However, you acknowledge that occasional errors or inaccuracies in automated content do not render the digital content faulty or of unsatisfactory quality.
    </p>

    <h4>7. Acceptance and Incorporation</h4>
    <p>
      By clicking "Accept and Generate Report", paying any fee, or otherwise generating, viewing, downloading, or using any report, you confirm that you have read, understood, and irrevocably agree to be bound by this Report Disclaimer & Limitation of Liability in its entirety.
    </p>

    <h4>8. Governing Law</h4>
    <p>
      This Report Disclaimer & Limitation of Liability and any disputes arising from or in connection with it shall be governed by and construed in accordance with the laws of England and Wales. The courts of England and Wales shall have exclusive jurisdiction over any such disputes.
    </p>
  </>
);

